/**
 * External dependencies
 */
import { combineReducers } from 'redux';
/**
 * Internal dependencies
 */

import { createReducer } from 'state/utils';
import {
    CURRENT_UNIVERSALIMPORTER_RECEIVE,
    CURRENT_UNIVERSALIMPORTER_REQUEST,
    CURRENT_UNIVERSALIMPORTER_REQUEST_SUCCESS,
    CURRENT_UNIVERSALIMPORTER_REQUEST_FAILURE,
} from 'state/action-types';

export const requesting = createReducer(false, {
    [CURRENT_UNIVERSALIMPORTER_REQUEST]: () => true,
    [CURRENT_UNIVERSALIMPORTER_REQUEST_SUCCESS]: () => false,
    [CURRENT_UNIVERSALIMPORTER_REQUEST_FAILURE]: () => false,
});

const items = createReducer(null, {
    [CURRENT_UNIVERSALIMPORTER_RECEIVE]: (state, action) => action.payload.universalimporter,
});

export const error = createReducer(false, {
    [CURRENT_UNIVERSALIMPORTER_REQUEST]: () => false,
    [CURRENT_UNIVERSALIMPORTER_REQUEST_SUCCESS]: () => false,
    [CURRENT_UNIVERSALIMPORTER_REQUEST_FAILURE]: () => true,
});

export default combineReducers({
    items,
    requesting,
    error
});
